export const parseQueryString = (url, data) => {
  const keys = Object.keys(data);
  let queryString = '?';
  keys.forEach((key, index) => {
    queryString += `${key}=${data[key]}${index === keys.length - 1 ? '' : '&'}`;
  });
  return `${url}${queryString}`;
};
